/**
 * DrawerLab™ Preset Templates
 * Each template defines an optimized drawer layout for specific clothing types
 */

(function() {

  window.DRAWER_TEMPLATES = {

    sokken_boxers: {
      name: 'Sokken & Onderbroeken',
      description: 'De ideale indeling voor je ondergoedlade',
      icon: '🧦🩲',
      presets: {
        pax100: { width: 901, depth: 533, height: 144, profileHeight: 90, layout: '3x2', material: 'pvc', color: 'orange' },
        pax75:  { width: 651, depth: 533, height: 144, profileHeight: 90, layout: '2x2', material: 'pvc', color: 'orange' },
        pax50:  { width: 401, depth: 533, height: 144, profileHeight: 90, layout: '2x1', material: 'pvc', color: 'orange' }
      },
      // Items per compartment (0-indexed, left-to-right, top-to-bottom)
      // For 3x2 layout: [0,1,2] top row, [3,4,5] bottom row
      compartments: {
        '3x2': [
          { vak: 0, type: 'socks', label: 'Sokken' },
          { vak: 1, type: 'socks', label: 'Sokken' },
          { vak: 2, type: 'boxers', label: 'Boxershorts' },
          { vak: 3, type: 'socks', label: 'Sokken' },
          { vak: 4, type: 'boxers', label: 'Boxershorts' },
          { vak: 5, type: 'boxers', label: 'Boxershorts' }
        ],
        '2x2': [
          { vak: 0, type: 'socks', label: 'Sokken' },
          { vak: 1, type: 'boxers', label: 'Boxershorts' },
          { vak: 2, type: 'socks', label: 'Sokken' },
          { vak: 3, type: 'boxers', label: 'Boxershorts' }
        ],
        '2x1': [
          { vak: 0, type: 'socks', label: 'Sokken' },
          { vak: 1, type: 'boxers', label: 'Boxershorts' }
        ]
      }
    },

    complete_ondergoed: {
      name: 'Complete Ondergoedlade',
      description: 'Sokken, onderbroeken en hemden — alles op z\'n plek',
      icon: '🧦🩲👕',
      presets: {
        pax100: { width: 901, depth: 533, height: 144, profileHeight: 90, layout: '3x2', material: 'pvc', color: 'beige' }
      },
      compartments: {
        '3x2': [
          { vak: 0, type: 'socks', label: 'Sokken' },
          { vak: 1, type: 'socks', label: 'Sokken' },
          { vak: 2, type: 'tshirts', label: 'Hemden' },
          { vak: 3, type: 'boxers', label: 'Boxershorts' },
          { vak: 4, type: 'boxers', label: 'Boxershorts' },
          { vak: 5, type: 'tshirts', label: 'Hemden' }
        ]
      }
    },

    kleding_lade: {
      name: 'Kledinglade',
      description: 'T-shirts, jeans en truien georganiseerd',
      icon: '👕👖',
      presets: {
        pax100: { width: 901, depth: 533, height: 144, profileHeight: 90, layout: '3x1', material: 'pvc', color: 'antracite' }
      },
      compartments: {
        '3x1': [
          { vak: 0, type: 'tshirts', label: 'T-shirts' },
          { vak: 1, type: 'tshirts', label: 'T-shirts' },
          { vak: 2, type: 'jeans', label: 'Jeans' }
        ]
      }
    },

    lingerie_lade: {
      name: 'Lingerielade',
      description: "BH's, slipjes en sokken netjes gescheiden",
      icon: '👙🧦',
      presets: {
        pax100: { width: 901, depth: 533, height: 144, profileHeight: 60, layout: '3x2', material: 'velvet', color: 'antracite' }
      },
      compartments: {
        '3x2': [
          { vak: 0, type: 'bras', label: "BH's" },
          { vak: 1, type: 'bras', label: "BH's" },
          { vak: 2, type: 'socks', label: 'Sokken' },
          { vak: 3, type: 'boxers', label: 'Slipjes' },
          { vak: 4, type: 'boxers', label: 'Slipjes' },
          { vak: 5, type: 'socks', label: 'Kousen' }
        ]
      }
    },

    truien_lade: {
      name: 'Truien & Sweaters',
      description: 'Truien netjes gevouwen en overzichtelijk',
      icon: '🧥',
      presets: {
        pax100: { width: 901, depth: 533, height: 144, profileHeight: 90, layout: '2x1', material: 'pvc', color: 'brown' }
      },
      compartments: {
        '2x1': [
          { vak: 0, type: 'sweaters', label: 'Truien' },
          { vak: 1, type: 'sweaters', label: 'Truien' }
        ]
      }
    }

  };

})();
